import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger
} from "../../../ui/tooltip";
import { ShortcutDisplay } from "../shortcuts/ShortcutDisplay";
import { ShortcutString } from "../shortcuts/shortcuts";

export interface EditorTooltipProps extends React.PropsWithChildren {
  message: React.ReactNode;
  shortcut?: ShortcutString;
  /**
   * Render the child element itself as the trigger instead of wrapping it
   * in a trigger button. Required when the child is interactive (button,
   * link) to avoid nested interactive elements.
   */
  asChild?: boolean;
}

export const EditorTooltip: React.FC<EditorTooltipProps> = ({
  children,
  message,
  shortcut,
  asChild = false
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className="flex items-center gap-1.5 text-xs">
          {message} {shortcut ? <ShortcutDisplay keys={shortcut} /> : undefined}
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
